import { api } from "../../lib/api";

export type PaymentMethod = {
  id: number;
  name: string;
  color: string;
  icon: string;
  discountPct: number;
  requiresNetReceived: boolean;
  requiresCustomer: boolean;
  settlesInBatch: boolean;
  displayOrder: number;
  active: boolean;
};

export type PaymentMethodInput = {
  name: string;
  color: "cash" | "transfer" | "card" | "other" | "magenta";
  icon: "Banknote" | "ArrowLeftRight" | "CreditCard" | "UserCircle";
  discountPct: number;
  requiresNetReceived: boolean;
  requiresCustomer: boolean;
  settlesInBatch: boolean;
  displayOrder: number;
};

export const paymentMethodsApi = {
  list: (includeInactive = false) =>
    api<PaymentMethod[]>(`/api/payment-methods${includeInactive ? "?includeInactive=true" : ""}`),
  create: (body: PaymentMethodInput) =>
    api<PaymentMethod>("/api/payment-methods", { method: "POST", body }),
  update: (id: number, body: Partial<PaymentMethodInput & { active: boolean }>) =>
    api<PaymentMethod>(`/api/payment-methods/${id}`, { method: "PATCH", body }),
  // Recibe la lista COMPLETA de ids (activos e inactivos) en el orden
  // deseado. El backend responde con la lista ya reordenada, serializada
  // igual que GET /api/payment-methods.
  reorder: (ids: number[]) =>
    api<PaymentMethod[]>("/api/payment-methods/reorder", { method: "PATCH", body: { ids } }),
};
